import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Paper,
  Divider,
  Container,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import axios from "../api";
import { CheckCircle, Error, Search } from "@material-ui/icons";
import { Header } from "../components";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(3),
    minHeight: "70vh", // Reducido para no desbordar el Layout
  },
  card: {
    maxWidth: 600,
    width: "100%",
    borderRadius: 20,
    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
    background: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(10px)",
  },
  header: {
    marginBottom: theme.spacing(3),
    textAlign: "center",
    color: "#1a237e",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    borderRadius: 12,
    fontWeight: "bold",
    textTransform: "none",
    fontSize: "1rem",
  },
  resultBox: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(3),
    borderRadius: 16,
    transition: "all 0.3s ease",
  },
  statusIcon: {
    fontSize: 60,
    marginBottom: theme.spacing(1),
  },
  logBox: {
    marginTop: theme.spacing(3),
    backgroundColor: "#1e1e1e",
    color: "#00ff00",
    padding: theme.spacing(2),
    borderRadius: 8,
    fontFamily: "monospace",
    fontSize: "0.85rem",
    maxHeight: 200,
    overflowY: "auto",
  },
}));

const ExternalTest = () => {
  const classes = useStyles();
  const [documento, setDocumento] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleConsult = async (e) => {
    e.preventDefault();
    if (!documento) return;

    setLoading(true);
    setResult(null);
    setError(null);

    try {
      // Usando axios desde el archivo api.js
      const response = await axios.post("/external/consultaEstudiante", {
        app_id: "zGQs97!a^u",
        key_id: "Z8p!JjEAAMq!e2z2Jj$&d7aULR#8Up",
        documento: documento,
      });

      setResult(response.data);
    } catch (err) {
      console.error("Error en la consulta:", err);
      setError(
        err.response?.data?.message || 
        "No se pudo conectar con el servidor o las credenciales son inválidas."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Herramientas" title="Prueba de Consulta Externa" />

      <Box className={classes.container}>
        <Container maxWidth="sm">
          <Card className={classes.card}>
            <CardContent style={{ padding: 40 }}>
              <Typography variant="body1" color="textSecondary" align="center" style={{ marginBottom: 30 }}>
                Ingresa el documento del estudiante para verificar su estado de evaluación en el Endpoint External.
              </Typography>

            <form onSubmit={handleConsult} className={classes.form}>
              <TextField
                label="Documento de Identidad"
                variant="outlined"
                fullWidth
                value={documento}
                onChange={(e) => setDocumento(e.target.value)}
                autoFocus
                placeholder="Ej: 12345678"
                InputProps={{
                  startAdornment: <Search style={{ marginRight: 8, color: "gray" }} />,
                }}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}
                disabled={loading || !documento}
                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
              >
                {loading ? "Consultando..." : "Verificar Estado"}
              </Button>
            </form>

            {error && (
              <Box mt={3}>
                <Alert severity="error" variant="filled">
                  {error}
                </Alert>
              </Box>
            )}

            {result && (
              <Box className={classes.resultBox}>
                <Divider />
                <Box textAlign="center" mt={3}>
                  {result.status && result.data?.estado ? (
                    <Box>
                      <CheckCircle className={classes.statusIcon} style={{ color: "#4caf50" }} />
                      <Typography variant="h5" style={{ color: "#2e7d32", fontWeight: "bold" }}>
                        ¡Estudiante al día!
                      </Typography>
                      <Typography variant="body1">
                        El estudiante ha completado todas sus evaluaciones.
                      </Typography>
                    </Box>
                  ) : (
                    <Box>
                      <Error className={classes.statusIcon} style={{ color: "#f44336" }} />
                      <Typography variant="h5" style={{ color: "#d32f2f", fontWeight: "bold" }}>
                        Evaluaciones Pendientes
                      </Typography>
                      <Typography variant="body1">
                        El estudiante tiene evaluaciones pendientes o no se encontraron periodos activos.
                      </Typography>
                    </Box>
                  )}
                </Box>

                <Box className={classes.logBox}>
                  <Typography variant="caption" display="block" gutterBottom style={{ color: "#aaa" }}>
                    Respuesta del Servidor (JSON):
                  </Typography>
                  <pre>{JSON.stringify(result, null, 2)}</pre>
                </Box>
              </Box>
            )}
          </CardContent>
        </Card>
      </Container>
    </Box>
    </div>
  );
};

export default ExternalTest;
